import React from 'react';
import { BadgeContainer, StyledCheckIcon, StyledArchivedIcon } from './VaultBadgeStatus.styled';
import { generateColumnTable } from '../../../../../utils/tableUtils';
import { StatusFilterEnum } from '../../enums/StatusFilterEnum';

const VaultBadgeStatus = ({ status }) => {
  const displayText = status.charAt(0).toUpperCase() + status.slice(1);
  
  return (
    <BadgeContainer status={status}>
      {status === StatusFilterEnum.ACTIVE && <StyledCheckIcon />}
      {status === StatusFilterEnum.ARCHIVED && <StyledArchivedIcon />}
      {displayText}
    </BadgeContainer>
  );
};

export const statusColumn = {
  ...generateColumnTable("status", "Status"),
  Cell: ({ cell }) => <VaultBadgeStatus status={cell.getValue() || StatusFilterEnum.ACTIVE} />,
};

export default VaultBadgeStatus; 